import React from "react";

const About = () => {
  return (
    <div id="fh5co-about" className="animate-box">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>About Me</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <h2 style={{ marginBottom: '15px' }}>Hello There!</h2>
            <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>I am a Master's student at the University of Wisconsin-Madison, passionate about solving real-world problems through innovative technologies. With over 4 years of experience, I have worked on distributed systems, machine learning, and big data, delivering scalable and impactful solutions.</p>
            <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>My journey began with a fascination for technology, leading me to pursue a career in software development. I thrive in collaborative environments and am always eager to learn and grow.</p>

            <h3 style={{ marginBottom: '10px', fontSize: '20px', fontWeight: 'bold' }}>Research Interests</h3>
            <p style={{ marginBottom: '25px', lineHeight: '1.6' }}>I'm particularly interested in distributed systems, cloud computing, and machine learning. My research focuses on developing scalable and efficient systems that can handle large volumes of data with low latency.</p>

            <p style={{ marginTop: '20px' }}>
              <ul className="fh5co-social-icons">
                <li><a href="https://linkedin.com/in/catchashu10"><i className="icon-linkedin2"></i></a></li>
                <li><a href="https://github.com/catchashu10"><i className="icon-github"></i></a></li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
